import { BgMealTypeEnum } from '../../../../../uc-api-sdk';

export const MealTypes = [
  BgMealTypeEnum.BREAKFAST,
  BgMealTypeEnum.LUNCH,
  BgMealTypeEnum.DINNER,
  BgMealTypeEnum.SNACK,
];
